import DOMPurify from "dompurify";

const hasHtmlTags = (value) => /<[^>]+>/.test(value);

const escapeHtml = (value) =>
  value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#039;");

const SafeHtmlContent = ({ html = "", className = "" }) => {
  if (!html) {
    return null;
  }

  const normalizedHtml = hasHtmlTags(html)
    ? DOMPurify.sanitize(html)
    : escapeHtml(html).replace(/\n/g, "<br />");

  return (
    <div
      className={className + " prose prose-headings:white"}
      dangerouslySetInnerHTML={{ __html: normalizedHtml }}
    />
  );
};

export default SafeHtmlContent;
